import webStorageManager from "@cbetancourt/webstorage-manager";
import config from "../config/webstorage";

const store = webStorageManager.configure(config);

export default store;
